import { api } from "../api";

export const UsuarioService = {
    login: async (data) => {
        const response = await api.post('/login', data);
        return response.data;
    },
    alterarSenha: async (token, data) => {
        const response = await api.patch('/senha', data, {
            headers: { "Authorization": token }
        });
        return response.data;
    }
}